export const applicationTabs = [
  {
    id: 'overview',
    title: 'Business Overview',
    icon: 'solar:home-smile-angle-bold',
    permission: 'authenticated'
  },
  {
    id: 'my-venues',
    title: 'My Venues',
    icon: 'solar:shop-2-bold',
    permission: 'authenticated'
  },
  {
    id: 'my-plan',
    title: 'My Plan',
    icon: 'solar:card-bold',
    permission: 'authenticated'
  },
  {
    id: 'categories',
    title: 'Categories',
    icon: 'solar:widget-bold',
    permission: 'content'
  },
  {
    id: 'all-venues',
    title: 'All Venues',
    icon: 'solar:buildings-3-bold',
    permission: 'venues'
  },
  {
    id: 'venue-verification',
    title: 'Venue Verification',
    icon: 'solar:shield-check-bold',
    permission: 'venues'
  },
  {
    id: 'vendor-analytics',
    title: 'Venue Analytics',
    icon: 'solar:chart-2-bold',
    permission: 'venues'
  },
  {
    id: 'venue-analytics',
    title: 'Venue Analytics',
    icon: 'solar:chart-2-bold',
    permission: 'venues'
  },
  {
    id: 'subscriptions',
    title: 'Subscriptions',
    icon: 'solar:wallet-money-bold',
    permission: 'finance'
  },
  {
    id: 'user-management',
    title: 'User Management',
    icon: 'solar:users-group-rounded-bold',
    permission: 'users'
  },
  {
    id: 'moderation',
    title: 'Reviews & Moderation',
    icon: 'solar:star-bold',
    permission: 'content'
  },
  {
    id: 'positions',
    title: 'Roles & Permissions',
    icon: 'solar:shield-user-bold',
    permission: 'positions'
  },
  {
    id: 'employees',
    title: 'Staff',
    icon: 'solar:users-group-two-rounded-bold',
    permission: 'employees'
  }
];
